export function hasData(root: any) {
  if(!root) return false
  const children = root.children
  if(!children || children.length != 1 ) return true
  const first = children[0]
  if( first.type != "paragraph" || first.children.length != 1 ) return true
  const second = first.children[0]
  if( second.children?.length == 0 && second.type == "paragraph" ) return false
  return true

}